package features.shifts.handlers

import kotlinx.browser.document
import shared.ui.ModalManager
import AppState
import Router
import features.shifts.domain.ShiftTemplate

// Global variables for shift color selection
var selectedShiftColor = "#10b981"
var selectedEditShiftColor = "#10b981"

// Color selection functions
fun selectShiftColor(color: String) {
    selectedShiftColor = color
}

fun selectEditShiftColor(color: String) {
    selectedEditShiftColor = color
}

// Exposed functions for custom color picker
@JsName("selectShiftColorFromPicker")
fun selectShiftColorFromPicker(color: String) {
    selectedShiftColor = color
    val picker = document.getElementById("shift-color-picker") as? org.w3c.dom.HTMLInputElement
    picker?.value = color
    
    // Update all color buttons to deselect
    listOf("#10b981", "#f59e0b", "#8b5cf6", "#ef4444", "#06b6d4").forEach { c ->
        val btn = document.getElementById("color-btn-$c") as? org.w3c.dom.HTMLElement
        btn?.style?.borderColor = "transparent"
    }
}

@JsName("selectEditShiftColorFromPicker")
fun selectEditShiftColorFromPicker(color: String) {
    selectedEditShiftColor = color
    val picker = document.getElementById("edit-shift-color-picker-input") as? org.w3c.dom.HTMLInputElement
    picker?.value = color
    
    // Update all color buttons to deselect
    listOf("#10b981", "#f59e0b", "#8b5cf6", "#ef4444", "#06b6d4").forEach { c ->
        val btn = document.getElementById("edit-color-btn-$c") as? org.w3c.dom.HTMLElement
        btn?.style?.borderColor = "transparent"
    }
}

// Shift Modal Functions
fun showCreateShiftModal() {
    // Reset form fields
    (document.getElementById("shift-code-input") as? org.w3c.dom.HTMLInputElement)?.value = ""
    (document.getElementById("shift-start-hour") as? org.w3c.dom.HTMLSelectElement)?.value = "00"
    (document.getElementById("shift-start-minute") as? org.w3c.dom.HTMLSelectElement)?.value = "00"
    (document.getElementById("shift-end-hour") as? org.w3c.dom.HTMLSelectElement)?.value = "00"
    (document.getElementById("shift-end-minute") as? org.w3c.dom.HTMLSelectElement)?.value = "00"
    
    // Reset color to default (green)
    selectedShiftColor = "#10b981"
    (document.getElementById("shift-color-picker") as? org.w3c.dom.HTMLInputElement)?.value = "#10b981"
    
    // Reset color button borders after modal is shown
    kotlinx.browser.window.setTimeout({
        listOf("#10b981", "#f59e0b", "#8b5cf6", "#ef4444", "#06b6d4").forEach { c ->
            val btn = document.getElementById("color-btn-$c") as? org.w3c.dom.HTMLElement
            btn?.style?.borderColor = if (c == "#10b981") "white" else "transparent"
        }
    }, 100)
    
    ModalManager.show("create-shift-modal")
}

fun showEditShiftModal(shift: ShiftTemplate) {
    // Populate form with shift data
    (document.getElementById("edit-shift-id") as? org.w3c.dom.HTMLInputElement)?.value = shift.id
    (document.getElementById("edit-shift-code") as? org.w3c.dom.HTMLInputElement)?.value = shift.code
    
    if (shift.startTime != "-") {
        val startParts = shift.startTime.split(":")
        (document.getElementById("edit-shift-start-hour") as? org.w3c.dom.HTMLSelectElement)?.value = startParts[0]
        (document.getElementById("edit-shift-start-minute") as? org.w3c.dom.HTMLSelectElement)?.value = startParts[1]
        
        val endParts = shift.endTime.split(":")
        (document.getElementById("edit-shift-end-hour") as? org.w3c.dom.HTMLSelectElement)?.value = endParts[0]
        (document.getElementById("edit-shift-end-minute") as? org.w3c.dom.HTMLSelectElement)?.value = endParts[1]
    }
    
    selectedEditShiftColor = shift.color
    (document.getElementById("edit-shift-color-picker-input") as? org.w3c.dom.HTMLInputElement)?.value = shift.color
    
    ModalManager.show("edit-shift-modal")
}

fun deleteShiftConfirm(shiftId: String, shiftCode: String) {
    val confirmed = kotlinx.browser.window.confirm("Are you sure you want to delete shift '$shiftCode'?")
    if (confirmed) {
        val teamId = AppState.currentTeam?.id ?: return
        features.shifts.data.ShiftRepository.deleteShift(teamId, shiftId)
            .then {
                console.log("Shift deleted successfully")
                // Remove from AppState
                AppState.shiftTemplates[teamId]?.removeAll { it.id == shiftId }
                Router.render()
            }
            .catch { error ->
                console.error("Error deleting shift:", error)
                kotlinx.browser.window.alert("Failed to delete shift")
            }
    }
}
